// Commercial switches and sender identity for the free report and the outreach
// dialog. One file, so opening the sale is a reviewable one-line diff.
export const SALES = {
  priceEur: 39,
  deliveryHours: 24,
  // Flip ONLY after a payment provider is wired AND AGB/Widerruf are reviewed by
  // a lawyer. While false, the offer block shows price, contents and the
  // delivery promise, but never payment methods / MwSt. wording.
  paymentLive: false,
  // Flip ONLY after the refund wording is reviewed by a lawyer — a badly phrased
  // one can read as a broader warranty.
  guaranteeLive: false,
  // Flip ONLY when the real Impressum / AGB / Datenschutz text is in place: the
  // current /impressum /agb /datenschutz pages declare themselves placeholders,
  // so the free report must not link to them until then.
  legalPagesLive: false,
};

// Explicit property reads (not process.env[k]) so the bundler can inline them.
export const SENDER = {
  name: (process.env.REACT_APP_SENDER_NAME || "").trim(),
  company: (process.env.REACT_APP_SENDER_COMPANY || "").trim(),
  phone: (process.env.REACT_APP_SENDER_PHONE || "").trim(),
  email: (process.env.REACT_APP_SENDER_EMAIL || "").trim(),
};

export const senderMissing = (sender = SENDER) =>
  ["name", "phone", "email"].filter((k) => !(sender[k] || "").trim());

export const whatsappLink = (phone) => {
  const digits = (phone || "").replace(/[^\d]/g, "");
  return digits ? `https://wa.me/${digits}` : null;
};

export const priceLabel = (lang, price = SALES.priceEur) =>
  lang === "en" ? `€${price}` : `${price} €`;
